// source: pangolin/protos/network.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.pangolin.protos.GetNetworkCountersResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetNetworkHistoryResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetNetworkThroughputResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.NetworkCountersObject', null, global);
goog.exportSymbol('proto.pangolin.protos.NetworkHistoryDirection', null, global);
goog.exportSymbol('proto.pangolin.protos.NetworkHistoryLocationObject', null, global);
goog.exportSymbol('proto.pangolin.protos.NetworkHistoryObject', null, global);
goog.exportSymbol('proto.pangolin.protos.NetworkHistoryObjectList', null, global);
goog.exportSymbol('proto.pangolin.protos.NetworkThroughputObject', null, global);
goog.exportSymbol('proto.pangolin.protos.NetworkThroughputObjectList', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.NetworkCountersObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.NetworkCountersObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.NetworkCountersObject.displayName = 'proto.pangolin.protos.NetworkCountersObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.NetworkHistoryLocationObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.NetworkHistoryLocationObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.NetworkHistoryLocationObject.displayName = 'proto.pangolin.protos.NetworkHistoryLocationObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.NetworkHistoryObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.NetworkHistoryObject.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.NetworkHistoryObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.NetworkHistoryObject.displayName = 'proto.pangolin.protos.NetworkHistoryObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.NetworkHistoryObjectList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.NetworkHistoryObjectList.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.NetworkHistoryObjectList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.NetworkHistoryObjectList.displayName = 'proto.pangolin.protos.NetworkHistoryObjectList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.NetworkThroughputObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.NetworkThroughputObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.NetworkThroughputObject.displayName = 'proto.pangolin.protos.NetworkThroughputObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.NetworkThroughputObjectList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.NetworkThroughputObjectList.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.NetworkThroughputObjectList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.NetworkThroughputObjectList.displayName = 'proto.pangolin.protos.NetworkThroughputObjectList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetNetworkCountersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetNetworkCountersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetNetworkCountersResponse.displayName = 'proto.pangolin.protos.GetNetworkCountersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetNetworkHistoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetNetworkHistoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetNetworkHistoryResponse.displayName = 'proto.pangolin.protos.GetNetworkHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetNetworkThroughputResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetNetworkThroughputResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetNetworkThroughputResponse.displayName = 'proto.pangolin.protos.GetNetworkThroughputResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.NetworkCountersObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.NetworkCountersObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.NetworkCountersObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    filtersTotal: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    filtersBlocked: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    adblockTotal: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    adblockBlocked: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    maliciousTotal: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    maliciousBlocked: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    malwareTotal: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    malwareBlocked: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.NetworkCountersObject}
 */
proto.pangolin.protos.NetworkCountersObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.NetworkCountersObject;
  return proto.pangolin.protos.NetworkCountersObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.NetworkCountersObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.NetworkCountersObject}
 */
proto.pangolin.protos.NetworkCountersObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFiltersTotal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFiltersBlocked(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdblockTotal(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdblockBlocked(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaliciousTotal(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaliciousBlocked(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMalwareTotal(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMalwareBlocked(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.NetworkCountersObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.NetworkCountersObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.NetworkCountersObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional int64 filters_total = 1;
 * @return {number}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.getFiltersTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkCountersObject} returns this
 */
proto.pangolin.protos.NetworkCountersObject.prototype.setFiltersTotal = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkCountersObject} returns this
 */
proto.pangolin.protos.NetworkCountersObject.prototype.clearFiltersTotal = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.hasFiltersTotal = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 filters_blocked = 2;
 * @return {number}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.getFiltersBlocked = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkCountersObject} returns this
 */
proto.pangolin.protos.NetworkCountersObject.prototype.setFiltersBlocked = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkCountersObject} returns this
 */
proto.pangolin.protos.NetworkCountersObject.prototype.clearFiltersBlocked = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.hasFiltersBlocked = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 adblock_total = 3;
 * @return {number}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.getAdblockTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkCountersObject} returns this
 */
proto.pangolin.protos.NetworkCountersObject.prototype.setAdblockTotal = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkCountersObject} returns this
 */
proto.pangolin.protos.NetworkCountersObject.prototype.clearAdblockTotal = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.hasAdblockTotal = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 adblock_blocked = 4;
 * @return {number}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.getAdblockBlocked = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkCountersObject} returns this
 */
proto.pangolin.protos.NetworkCountersObject.prototype.setAdblockBlocked = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkCountersObject} returns this
 */
proto.pangolin.protos.NetworkCountersObject.prototype.clearAdblockBlocked = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.hasAdblockBlocked = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int64 malicious_total = 5;
 * @return {number}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.getMaliciousTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkCountersObject} returns this
 */
proto.pangolin.protos.NetworkCountersObject.prototype.setMaliciousTotal = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkCountersObject} returns this
 */
proto.pangolin.protos.NetworkCountersObject.prototype.clearMaliciousTotal = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.hasMaliciousTotal = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 malicious_blocked = 6;
 * @return {number}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.getMaliciousBlocked = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkCountersObject} returns this
 */
proto.pangolin.protos.NetworkCountersObject.prototype.setMaliciousBlocked = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkCountersObject} returns this
 */
proto.pangolin.protos.NetworkCountersObject.prototype.clearMaliciousBlocked = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.hasMaliciousBlocked = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int64 malware_total = 7;
 * @return {number}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.getMalwareTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkCountersObject} returns this
 */
proto.pangolin.protos.NetworkCountersObject.prototype.setMalwareTotal = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkCountersObject} returns this
 */
proto.pangolin.protos.NetworkCountersObject.prototype.clearMalwareTotal = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.hasMalwareTotal = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int64 malware_blocked = 8;
 * @return {number}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.getMalwareBlocked = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkCountersObject} returns this
 */
proto.pangolin.protos.NetworkCountersObject.prototype.setMalwareBlocked = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkCountersObject} returns this
 */
proto.pangolin.protos.NetworkCountersObject.prototype.clearMalwareBlocked = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkCountersObject.prototype.hasMalwareBlocked = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.NetworkHistoryLocationObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.NetworkHistoryLocationObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.NetworkHistoryLocationObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    countryShort: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    countryLong: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    region: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    city: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    zipcode: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    timezone: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    ip: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    longitude: (f = jspb.Message.getOptionalFloatingPointField(msg, 8)) == null ? undefined : f,
    latitude: (f = jspb.Message.getOptionalFloatingPointField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.NetworkHistoryLocationObject;
  return proto.pangolin.protos.NetworkHistoryLocationObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.NetworkHistoryLocationObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryShort(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryLong(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipcode(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezone(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setIp(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.NetworkHistoryLocationObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.NetworkHistoryLocationObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.NetworkHistoryLocationObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeDouble(
      9,
      f
    );
  }
};


/**
 * optional string country_short = 1;
 * @return {string}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.getCountryShort = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.setCountryShort = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.clearCountryShort = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.hasCountryShort = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string country_long = 2;
 * @return {string}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.getCountryLong = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.setCountryLong = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.clearCountryLong = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.hasCountryLong = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string region = 3;
 * @return {string}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.setRegion = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.clearRegion = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.hasRegion = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string city = 4;
 * @return {string}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.setCity = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.clearCity = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.hasCity = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string zipcode = 5;
 * @return {string}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.getZipcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.setZipcode = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.clearZipcode = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.hasZipcode = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string timezone = 6;
 * @return {string}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.getTimezone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.setTimezone = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.clearTimezone = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.hasTimezone = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string ip = 7;
 * @return {string}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.getIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.setIp = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.clearIp = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.hasIp = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional double longitude = 8;
 * @return {number}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.setLongitude = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.clearLongitude = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.hasLongitude = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional double latitude = 9;
 * @return {number}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.setLatitude = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryLocationObject} returns this
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.clearLatitude = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryLocationObject.prototype.hasLatitude = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.NetworkHistoryObject.repeatedFields_ = [19,20];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.NetworkHistoryObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.NetworkHistoryObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.NetworkHistoryObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    order: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    ctid: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    start: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    last: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    direction: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    macSrc: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    macDst: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    protoL3: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
    addrSrc: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
    addrDst: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
    protoL4: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f,
    portSrc: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f,
    portDst: (f = jspb.Message.getField(msg, 13)) == null ? undefined : f,
    pktsOrig: (f = jspb.Message.getField(msg, 14)) == null ? undefined : f,
    pktsRepl: (f = jspb.Message.getField(msg, 15)) == null ? undefined : f,
    bytesOrig: (f = jspb.Message.getField(msg, 16)) == null ? undefined : f,
    bytesRepl: (f = jspb.Message.getField(msg, 17)) == null ? undefined : f,
    allowed: (f = jspb.Message.getBooleanField(msg, 18)) == null ? undefined : f,
    domainsSrcList: (f = jspb.Message.getRepeatedField(msg, 19)) == null ? undefined : f,
    domainsDstList: (f = jspb.Message.getRepeatedField(msg, 20)) == null ? undefined : f,
    locationSrc: (f = msg.getLocationSrc()) && proto.pangolin.protos.NetworkHistoryLocationObject.toObject(includeInstance, f),
    locationDst: (f = msg.getLocationDst()) && proto.pangolin.protos.NetworkHistoryLocationObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.NetworkHistoryObject}
 */
proto.pangolin.protos.NetworkHistoryObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.NetworkHistoryObject;
  return proto.pangolin.protos.NetworkHistoryObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.NetworkHistoryObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.NetworkHistoryObject}
 */
proto.pangolin.protos.NetworkHistoryObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOrder(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCtid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setStart(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLast(value);
      break;
    case 5:
      var value = /** @type {!proto.pangolin.protos.NetworkHistoryDirection} */ (reader.readEnum());
      msg.setDirection(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMacSrc(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMacDst(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setProtoL3(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddrSrc(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddrDst(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setProtoL4(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPortSrc(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPortDst(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPktsOrig(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPktsRepl(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBytesOrig(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBytesRepl(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowed(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.addDomainsSrc(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.addDomainsDst(value);
      break;
    case 21:
      var value = new proto.pangolin.protos.NetworkHistoryLocationObject;
      reader.readMessage(value,proto.pangolin.protos.NetworkHistoryLocationObject.deserializeBinaryFromReader);
      msg.setLocationSrc(value);
      break;
    case 22:
      var value = new proto.pangolin.protos.NetworkHistoryLocationObject;
      reader.readMessage(value,proto.pangolin.protos.NetworkHistoryLocationObject.deserializeBinaryFromReader);
      msg.setLocationDst(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.NetworkHistoryObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.NetworkHistoryObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.NetworkHistoryObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = /** @type {!proto.pangolin.protos.NetworkHistoryDirection} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeUint32(
      13,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeUint64(
      14,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeUint64(
      15,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeUint64(
      16,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeUint64(
      17,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getDomainsSrcList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      19,
      f
    );
  }
  f = message.getDomainsDstList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      20,
      f
    );
  }
  f = message.getLocationSrc();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.pangolin.protos.NetworkHistoryLocationObject.serializeBinaryToWriter
    );
  }
  f = message.getLocationDst();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.pangolin.protos.NetworkHistoryLocationObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 order = 1;
 * @return {number}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setOrder = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearOrder = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasOrder = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint32 ctid = 2;
 * @return {number}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getCtid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setCtid = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearCtid = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasCtid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint64 start = 3;
 * @return {number}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setStart = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearStart = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasStart = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint64 last = 4;
 * @return {number}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getLast = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setLast = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearLast = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasLast = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional NetworkHistoryDirection direction = 5;
 * @return {!proto.pangolin.protos.NetworkHistoryDirection}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getDirection = function() {
  return /** @type {!proto.pangolin.protos.NetworkHistoryDirection} */ (jspb.Message.getFieldWithDefault(this, 5, 1));
};


/**
 * @param {!proto.pangolin.protos.NetworkHistoryDirection} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setDirection = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearDirection = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasDirection = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string mac_src = 6;
 * @return {string}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getMacSrc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setMacSrc = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearMacSrc = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasMacSrc = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string mac_dst = 7;
 * @return {string}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getMacDst = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setMacDst = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearMacDst = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasMacDst = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional uint32 proto_l3 = 8;
 * @return {number}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getProtoL3 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setProtoL3 = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearProtoL3 = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasProtoL3 = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string addr_src = 9;
 * @return {string}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getAddrSrc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setAddrSrc = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearAddrSrc = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasAddrSrc = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string addr_dst = 10;
 * @return {string}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getAddrDst = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setAddrDst = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearAddrDst = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasAddrDst = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional uint32 proto_l4 = 11;
 * @return {number}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getProtoL4 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setProtoL4 = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearProtoL4 = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasProtoL4 = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional uint32 port_src = 12;
 * @return {number}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getPortSrc = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setPortSrc = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearPortSrc = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasPortSrc = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional uint32 port_dst = 13;
 * @return {number}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getPortDst = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setPortDst = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearPortDst = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasPortDst = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional uint64 pkts_orig = 14;
 * @return {number}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getPktsOrig = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setPktsOrig = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearPktsOrig = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasPktsOrig = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional uint64 pkts_repl = 15;
 * @return {number}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getPktsRepl = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setPktsRepl = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearPktsRepl = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasPktsRepl = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional uint64 bytes_orig = 16;
 * @return {number}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getBytesOrig = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setBytesOrig = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearBytesOrig = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasBytesOrig = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional uint64 bytes_repl = 17;
 * @return {number}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getBytesRepl = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setBytesRepl = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearBytesRepl = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasBytesRepl = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional bool allowed = 18;
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getAllowed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setAllowed = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearAllowed = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasAllowed = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * repeated string domains_src = 19;
 * @return {!Array<string>}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getDomainsSrcList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 19));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setDomainsSrcList = function(value) {
  return jspb.Message.setField(this, 19, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.addDomainsSrc = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 19, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearDomainsSrcList = function() {
  return this.setDomainsSrcList([]);
};


/**
 * repeated string domains_dst = 20;
 * @return {!Array<string>}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getDomainsDstList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 20));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.setDomainsDstList = function(value) {
  return jspb.Message.setField(this, 20, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.addDomainsDst = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 20, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearDomainsDstList = function() {
  return this.setDomainsDstList([]);
};


/**
 * optional NetworkHistoryLocationObject location_src = 21;
 * @return {?proto.pangolin.protos.NetworkHistoryLocationObject}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getLocationSrc = function() {
  return /** @type{?proto.pangolin.protos.NetworkHistoryLocationObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.NetworkHistoryLocationObject, 21));
};


/**
 * @param {?proto.pangolin.protos.NetworkHistoryLocationObject|undefined} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
*/
proto.pangolin.protos.NetworkHistoryObject.prototype.setLocationSrc = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearLocationSrc = function() {
  return this.setLocationSrc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasLocationSrc = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional NetworkHistoryLocationObject location_dst = 22;
 * @return {?proto.pangolin.protos.NetworkHistoryLocationObject}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.getLocationDst = function() {
  return /** @type{?proto.pangolin.protos.NetworkHistoryLocationObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.NetworkHistoryLocationObject, 22));
};


/**
 * @param {?proto.pangolin.protos.NetworkHistoryLocationObject|undefined} value
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
*/
proto.pangolin.protos.NetworkHistoryObject.prototype.setLocationDst = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.NetworkHistoryObject} returns this
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.clearLocationDst = function() {
  return this.setLocationDst(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkHistoryObject.prototype.hasLocationDst = function() {
  return jspb.Message.getField(this, 22) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.NetworkHistoryObjectList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.NetworkHistoryObjectList.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.NetworkHistoryObjectList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.NetworkHistoryObjectList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.NetworkHistoryObjectList.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.NetworkHistoryObject.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.NetworkHistoryObjectList}
 */
proto.pangolin.protos.NetworkHistoryObjectList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.NetworkHistoryObjectList;
  return proto.pangolin.protos.NetworkHistoryObjectList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.NetworkHistoryObjectList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.NetworkHistoryObjectList}
 */
proto.pangolin.protos.NetworkHistoryObjectList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.NetworkHistoryObject;
      reader.readMessage(value,proto.pangolin.protos.NetworkHistoryObject.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.NetworkHistoryObjectList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.NetworkHistoryObjectList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.NetworkHistoryObjectList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.NetworkHistoryObjectList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.NetworkHistoryObject.serializeBinaryToWriter
    );
  }
};


/**
 * repeated NetworkHistoryObject items = 1;
 * @return {!Array<!proto.pangolin.protos.NetworkHistoryObject>}
 */
proto.pangolin.protos.NetworkHistoryObjectList.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.NetworkHistoryObject>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.NetworkHistoryObject, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.NetworkHistoryObject>} value
 * @return {!proto.pangolin.protos.NetworkHistoryObjectList} returns this
*/
proto.pangolin.protos.NetworkHistoryObjectList.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.NetworkHistoryObject=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.NetworkHistoryObject}
 */
proto.pangolin.protos.NetworkHistoryObjectList.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.NetworkHistoryObject, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.NetworkHistoryObjectList} returns this
 */
proto.pangolin.protos.NetworkHistoryObjectList.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.NetworkThroughputObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.NetworkThroughputObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.NetworkThroughputObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeStart: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    timeEnd: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    egrPkts: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    egrBytes: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    ingPkts: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    ingBytes: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    intPkts: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    intBytes: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
    allPkts: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
    allBytes: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.NetworkThroughputObject}
 */
proto.pangolin.protos.NetworkThroughputObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.NetworkThroughputObject;
  return proto.pangolin.protos.NetworkThroughputObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.NetworkThroughputObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.NetworkThroughputObject}
 */
proto.pangolin.protos.NetworkThroughputObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimeStart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimeEnd(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setEgrPkts(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setEgrBytes(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setIngPkts(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setIngBytes(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setIntPkts(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setIntBytes(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAllPkts(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAllBytes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.NetworkThroughputObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.NetworkThroughputObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.NetworkThroughputObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeUint64(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeUint64(
      10,
      f
    );
  }
};


/**
 * optional uint64 time_start = 1;
 * @return {number}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.getTimeStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.setTimeStart = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.clearTimeStart = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.hasTimeStart = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint64 time_end = 2;
 * @return {number}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.getTimeEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.setTimeEnd = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.clearTimeEnd = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.hasTimeEnd = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint64 egr_pkts = 3;
 * @return {number}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.getEgrPkts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.setEgrPkts = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.clearEgrPkts = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.hasEgrPkts = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint64 egr_bytes = 4;
 * @return {number}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.getEgrBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.setEgrBytes = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.clearEgrBytes = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.hasEgrBytes = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional uint64 ing_pkts = 5;
 * @return {number}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.getIngPkts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.setIngPkts = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.clearIngPkts = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.hasIngPkts = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional uint64 ing_bytes = 6;
 * @return {number}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.getIngBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.setIngBytes = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.clearIngBytes = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.hasIngBytes = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional uint64 int_pkts = 7;
 * @return {number}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.getIntPkts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.setIntPkts = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.clearIntPkts = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.hasIntPkts = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional uint64 int_bytes = 8;
 * @return {number}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.getIntBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.setIntBytes = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.clearIntBytes = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.hasIntBytes = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional uint64 all_pkts = 9;
 * @return {number}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.getAllPkts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.setAllPkts = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.clearAllPkts = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.hasAllPkts = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional uint64 all_bytes = 10;
 * @return {number}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.getAllBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.setAllBytes = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.NetworkThroughputObject} returns this
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.clearAllBytes = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.NetworkThroughputObject.prototype.hasAllBytes = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.NetworkThroughputObjectList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.NetworkThroughputObjectList.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.NetworkThroughputObjectList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.NetworkThroughputObjectList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.NetworkThroughputObjectList.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.NetworkThroughputObject.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.NetworkThroughputObjectList}
 */
proto.pangolin.protos.NetworkThroughputObjectList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.NetworkThroughputObjectList;
  return proto.pangolin.protos.NetworkThroughputObjectList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.NetworkThroughputObjectList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.NetworkThroughputObjectList}
 */
proto.pangolin.protos.NetworkThroughputObjectList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.NetworkThroughputObject;
      reader.readMessage(value,proto.pangolin.protos.NetworkThroughputObject.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.NetworkThroughputObjectList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.NetworkThroughputObjectList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.NetworkThroughputObjectList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.NetworkThroughputObjectList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.NetworkThroughputObject.serializeBinaryToWriter
    );
  }
};


/**
 * repeated NetworkThroughputObject items = 1;
 * @return {!Array<!proto.pangolin.protos.NetworkThroughputObject>}
 */
proto.pangolin.protos.NetworkThroughputObjectList.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.NetworkThroughputObject>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.NetworkThroughputObject, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.NetworkThroughputObject>} value
 * @return {!proto.pangolin.protos.NetworkThroughputObjectList} returns this
*/
proto.pangolin.protos.NetworkThroughputObjectList.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.NetworkThroughputObject=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.NetworkThroughputObject}
 */
proto.pangolin.protos.NetworkThroughputObjectList.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.NetworkThroughputObject, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.NetworkThroughputObjectList} returns this
 */
proto.pangolin.protos.NetworkThroughputObjectList.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetNetworkCountersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetNetworkCountersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetNetworkCountersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetNetworkCountersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    counters: (f = msg.getCounters()) && proto.pangolin.protos.NetworkCountersObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetNetworkCountersResponse}
 */
proto.pangolin.protos.GetNetworkCountersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetNetworkCountersResponse;
  return proto.pangolin.protos.GetNetworkCountersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetNetworkCountersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetNetworkCountersResponse}
 */
proto.pangolin.protos.GetNetworkCountersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.NetworkCountersObject;
      reader.readMessage(value,proto.pangolin.protos.NetworkCountersObject.deserializeBinaryFromReader);
      msg.setCounters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetNetworkCountersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetNetworkCountersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetNetworkCountersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetNetworkCountersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCounters();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.NetworkCountersObject.serializeBinaryToWriter
    );
  }
};


/**
 * required NetworkCountersObject counters = 1;
 * @return {!proto.pangolin.protos.NetworkCountersObject}
 */
proto.pangolin.protos.GetNetworkCountersResponse.prototype.getCounters = function() {
  return /** @type{!proto.pangolin.protos.NetworkCountersObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.NetworkCountersObject, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.NetworkCountersObject} value
 * @return {!proto.pangolin.protos.GetNetworkCountersResponse} returns this
*/
proto.pangolin.protos.GetNetworkCountersResponse.prototype.setCounters = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.GetNetworkCountersResponse} returns this
 */
proto.pangolin.protos.GetNetworkCountersResponse.prototype.clearCounters = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetNetworkCountersResponse.prototype.hasCounters = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetNetworkHistoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetNetworkHistoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetNetworkHistoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetNetworkHistoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    history: (f = msg.getHistory()) && proto.pangolin.protos.NetworkHistoryObjectList.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetNetworkHistoryResponse}
 */
proto.pangolin.protos.GetNetworkHistoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetNetworkHistoryResponse;
  return proto.pangolin.protos.GetNetworkHistoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetNetworkHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetNetworkHistoryResponse}
 */
proto.pangolin.protos.GetNetworkHistoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.NetworkHistoryObjectList;
      reader.readMessage(value,proto.pangolin.protos.NetworkHistoryObjectList.deserializeBinaryFromReader);
      msg.setHistory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetNetworkHistoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetNetworkHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetNetworkHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetNetworkHistoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHistory();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.NetworkHistoryObjectList.serializeBinaryToWriter
    );
  }
};


/**
 * required NetworkHistoryObjectList history = 1;
 * @return {!proto.pangolin.protos.NetworkHistoryObjectList}
 */
proto.pangolin.protos.GetNetworkHistoryResponse.prototype.getHistory = function() {
  return /** @type{!proto.pangolin.protos.NetworkHistoryObjectList} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.NetworkHistoryObjectList, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.NetworkHistoryObjectList} value
 * @return {!proto.pangolin.protos.GetNetworkHistoryResponse} returns this
*/
proto.pangolin.protos.GetNetworkHistoryResponse.prototype.setHistory = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.GetNetworkHistoryResponse} returns this
 */
proto.pangolin.protos.GetNetworkHistoryResponse.prototype.clearHistory = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetNetworkHistoryResponse.prototype.hasHistory = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetNetworkThroughputResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetNetworkThroughputResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetNetworkThroughputResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetNetworkThroughputResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    throughput: (f = msg.getThroughput()) && proto.pangolin.protos.NetworkThroughputObjectList.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetNetworkThroughputResponse}
 */
proto.pangolin.protos.GetNetworkThroughputResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetNetworkThroughputResponse;
  return proto.pangolin.protos.GetNetworkThroughputResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetNetworkThroughputResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetNetworkThroughputResponse}
 */
proto.pangolin.protos.GetNetworkThroughputResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.NetworkThroughputObjectList;
      reader.readMessage(value,proto.pangolin.protos.NetworkThroughputObjectList.deserializeBinaryFromReader);
      msg.setThroughput(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetNetworkThroughputResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetNetworkThroughputResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetNetworkThroughputResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetNetworkThroughputResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getThroughput();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.NetworkThroughputObjectList.serializeBinaryToWriter
    );
  }
};


/**
 * required NetworkThroughputObjectList throughput = 1;
 * @return {!proto.pangolin.protos.NetworkThroughputObjectList}
 */
proto.pangolin.protos.GetNetworkThroughputResponse.prototype.getThroughput = function() {
  return /** @type{!proto.pangolin.protos.NetworkThroughputObjectList} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.NetworkThroughputObjectList, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.NetworkThroughputObjectList} value
 * @return {!proto.pangolin.protos.GetNetworkThroughputResponse} returns this
*/
proto.pangolin.protos.GetNetworkThroughputResponse.prototype.setThroughput = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.GetNetworkThroughputResponse} returns this
 */
proto.pangolin.protos.GetNetworkThroughputResponse.prototype.clearThroughput = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetNetworkThroughputResponse.prototype.hasThroughput = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * @enum {number}
 */
proto.pangolin.protos.NetworkHistoryDirection = {
  N_H_DIRECTION_EGRESS: 1,
  N_H_DIRECTION_INGRESS: 2,
  N_H_DIRECTION_INTERNAL: 3,
  N_H_DIRECTION_EX_OUTPUT: 4,
  N_H_DIRECTION_EX_INPUT: 5,
  N_H_DIRECTION_IN_OUTPUT: 6,
  N_H_DIRECTION_IN_INPUT: 7,
  N_H_DIRECTION_LOOPBACK: 8,
  N_H_DIRECTION_INVALID: 9
};

goog.object.extend(exports, proto.pangolin.protos);
